(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-marketplace/assets/javascripts/route-play-marketplace.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-marketplace/assets/javascripts/route-play-marketplace.js');

'use strict';

const {
  useEffect,
  useCallback
} = React;
const {
  useSelector,
  useStore,
  useDispatch
} = ReactRedux;
const {
  loadCoOpData
} = svs.components.marketplaceShared.coOpPlay.helpers;
const {
  reducers: marketplacedReducers
} = svs.components.marketplaceData.store;
const {
  CoOpPlayFilterReducer,
  CoOpPlayResultsReducer
} = svs.components.marketplaceShared.coOpPlay.reducers;
const {
  coOpPlayMiddleware,
  searchQueryMiddleware,
  gaMiddleware,
  createKibanaMiddleware
} = svs.components.marketplaceShared.coOpPlay.middlewares;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  getProductBrandByDraw
} = svs.components.lbUtils.brandMapping.fn;
const {
  CoOpPlayMarketplace
} = svs.components.tipsen;
const {
  DialogWrapper
} = svs.components.marketplaceShared.dialogWrapper;
const {
  closeDialog
} = svs.components.marketplaceData.dialogWrapper.actions;
const Dialogs = () => {
  const dialogInfo = useSelector(state => state.Dialog);
  const dispatch = useDispatch();
  const onClose = useCallback(() => {
    dispatch(closeDialog());
  }, [dispatch]);
  return React.createElement(DialogWrapper, {
    dialogInfo: dialogInfo,
    onClose: onClose
  });
};
const RoutePlayMarketplace = () => {
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const marketplaceBranding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const store = useStore();

  const reducerInStore = useSelector(state => state.CoOpPlayResults);
  useEffect(() => {
    const middlewares = [searchQueryMiddleware, coOpPlayMiddleware, gaMiddleware, createKibanaMiddleware()];
    const reducers = [{
      key: 'Dialog',
      reducer: marketplacedReducers.dialogWrapperReducer
    }, {
      key: 'Teams',
      reducer: marketplacedReducers.teamReducer
    }, {
      key: 'CoOpPlayFilter',
      reducer: CoOpPlayFilterReducer
    }, {
      key: 'CoOpPlayResults',
      reducer: CoOpPlayResultsReducer
    }, {
      key: 'FractionPayment',
      reducer: marketplacedReducers.fractionPaymentReducer
    }];
    middlewares.forEach(middleware => store.mwManager.add(middleware));
    reducers.forEach(_ref => {
      let {
        key,
        reducer
      } = _ref;
      return store.reducerManager.add(key, reducer);
    });
    return () => {
      middlewares.forEach(middleware => store.mwManager.remove(middleware));
      reducers.forEach(_ref2 => {
        let {
          key
        } = _ref2;
        return store.reducerManager.remove(key);
      });
    };
  }, [store.mwManager, store.reducerManager]);
  useEffect(() => {
    if (!reducerInStore) {
      loadCoOpData(store);
    }
  }, [store, reducerInStore]);
  return reducerInStore ? React.createElement(React.Fragment, null, React.createElement(Dialogs, null), React.createElement(CoOpPlayMarketplace, {
    branding: marketplaceBranding
  })) : null;
};
setGlobal('svs.components.tipsen.RoutePlayMarketplace', RoutePlayMarketplace);

 })(window);